import React, { useState } from 'react';
import { Section } from './ui/Section';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQ() {
  const faqs = [{
    q: '¿Cuánto tiempo toma al día?',
    a: '30 minutos total (10–10–10). Y tienes versiones mínimas para días caóticos donde solo tienes 5 minutos.'
  }, {
    q: '¿Necesito equipo o gimnasio?',
    a: 'No. Todo está diseñado para hacerse en casa con lo que ya tienes.'
  }, {
    q: '¿Y si tengo vida social?',
    a: "Incluye un 'plan de daño mínimo' específico para restaurantes, eventos y fines de semana."
  }];
  return <Section background="white" data-id="element-1">
      <h2 className="text-2xl font-bold text-center text-[#2C2C2C] mb-10" data-id="element-2">
        Preguntas Frecuentes
      </h2>

      <div className="space-y-4" data-id="element-3">
        {faqs.map((faq, idx) => <FAQItem key={idx} question={faq.q} answer={faq.a} data-id="element-4" />)}
      </div>
    </Section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-5">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex justify-between items-center p-5 bg-white hover:bg-gray-50 transition-colors text-left" data-id="element-6">
        <span className="font-medium text-[#2C2C2C]" data-id="element-7">{question}</span>
        {isOpen ? <ChevronUp className="text-[#D4735E]" data-id="element-8" /> : <ChevronDown className="text-gray-400" data-id="element-9" />}
      </button>

      <AnimatePresence data-id="element-10">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} className="bg-[#FFF8F0]" data-id="element-11">
            <div className="p-5 text-[#5A5A5A] text-sm leading-relaxed border-t border-gray-100" data-id="element-12">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}